"use client";

import { useSearchParams } from "next/navigation";
import Footer from "~/src/components/layouts/footer/Footer";
import Navbar from "~/src/components/layouts/navbar/Navbar";
import NavbarUserAnalysis from "~/src/components/layouts/navbar/NavbarUserAnalysis";
import { QUERY_PARAM_NAME_FROM } from "~/src/lib/ui/transition";

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  // クエリパラメータで、遷移元を特定
  const searchParams = useSearchParams();
  const from = searchParams.get(QUERY_PARAM_NAME_FROM);

  return (
    <>
      {/* ナビバー */}
      {from === null ? <Navbar /> : <NavbarUserAnalysis from={from} />}
      {/* main */}
      <main>{children}</main>
      {/* フッター */}
      <Footer />
    </>
  );
}
